import { useDispatch } from 'react-redux';
import { Box } from '@rsos/components/capstone/base';
import { toggleHarmonyChat } from '@rsos/reduxDataStore/src/features/harmonyChat/harmonyChatSlice';
import { ButtonWrapper, AskHarmonyButton } from './AskHarmonyBtn.styles';

export const AskHarmonyBtn = () => {
  const dispatch = useDispatch();
  const handleToggleChatPane = () => {
    dispatch(toggleHarmonyChat());
  };
  return (
    <Box horizontal onClick={handleToggleChatPane}>
      <ButtonWrapper horizontal>
        <AskHarmonyButton btnType="invisible" size="small" noMargin>
          Ask Harmony
        </AskHarmonyButton>
      </ButtonWrapper>
    </Box>
  );
};

export default AskHarmonyBtn;
